<template>
  <div>
    <audio controls>
      <source :src="src" />
    </audio>
  </div>
</template>

<script>
export default {
  name: "ChatVoice",
  props: ["src"]
};
</script>

<style scoped>

</style>